import React from 'react'

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell as BaseTableCell,
  TableBody
} from '@material-ui/core'
import { Text } from 'components/Typography/Basic'
import styled from 'styled-components'

const tableTitles = [
  'Category of Personal Information',
  'How we may use the Personal Information',
  'Legal Bases for processing',
  'Recipients of Personal Information'
]

const Annex1Table = () => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {tableTitles.map((tableTitle, index) => (
              <TableCell scope="col" key={index}>
                <Text fontSize="20px" align="center" as="h6">
                  {tableTitle}
                </Text>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell rowSpan="4">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Contact information
                </span>
                , such as first name, last name and email address.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to set up and authenticate your
                account on the European Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for the performance of a contract
                with you and to take steps prior to entering into a contract
                with you, namely our Terms of Service.
              </Text>
            </TableCell>
            <TableCell rowSpan="4">
              <Text align="center" as="p">
                We may share this information with Stripe, Inc. in order to
                identify you so that you can make and receive payments through
                the European Services.
              </Text>
              <Text align="center" as="p">
                We may also share your personal information with:
              </Text>
              <Text as="ul">
                <li>Impact Tech, Inc.</li>
                <li>Google LLC</li>
                <li>Facebook, Inc.</li>
                <li>Mode Analytics, Inc.</li>
                <li>Tableau Software, LLC</li>
                <li>RudderStack Inc.</li>
                <li>Reddit, Inc</li>
                <li>Brave Software, Inc.</li>
                <li>Twitter, Inc.</li>
                <li>LinkedIn Coproration</li>
                <li>Microsoft Corporation</li>
                <li>Outreach Corporation</li>
                <li>Cybba, Inc.</li>
                <li>Hotjar Ltd.</li>
                <li>Optimizely, Inc.</li>
                <li>Peaberry Software, Inc.</li>
                <li>Snap, Inc.</li>
                <li>TikTok, Inc.</li>
                <li>Twitch Interactive, Inc.</li>
                <li>Unbounce Marketing Solutions, Inc.</li>
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to communicate with you, including
                sending service-related communications.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for the performance of a contract
                with you, namely our Terms of Service.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to deal with enquiries and
                complaints made by or about you relating to the European
                Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                administering the European Services, and for communicating with
                you effectively to respond to your queries or complaints.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information in connection with providing you
                with marketing communications in accordance with your
                preferences.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We will only use your personal information in this way to the
                extent you have given us consent to do so.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Your registration / account
                </span>{' '}
                information such as your full name, email, and password. If you
                are a teacher, we may also ask for your gender, age, email
                address, languages spoken, location, phone number, general
                background as part of the “About You” section, and any web
                presence URL (e.g. Facebook handle or LinkedIn URL).
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to create your account on the
                European Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for the performance of a contract
                with you.
              </Text>
            </TableCell>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                We may also share your personal information with:
              </Text>
              <Text as="ul">
                <li>Impact Tech, Inc.</li>
                <li>Google LLC</li>
                <li>Facebook, Inc.</li>
                <li>Mode Analytics, Inc.</li>
                <li>Tableau Software, LLC</li>
                <li>RudderStack Inc.</li>
                <li>Reddit, Inc</li>
                <li>Brave Software, Inc.</li>
                <li>Twitter, Inc.</li>
                <li>LinkedIn Coproration</li>
                <li>Microsoft Corporation</li>
                <li>Outreach Corporation</li>
                <li>Cybba, Inc.</li>
                <li>Hotjar Ltd.</li>
                <li>Optimizely, Inc.</li>
                <li>Peaberry Software, Inc.</li>
                <li>Snap, Inc.</li>
                <li>TikTok, Inc.</li>
                <li>Twitch Interactive, Inc.</li>
                <li>Unbounce Marketing Solutions, Inc.</li>
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We use this information to deal with enquiries and complaints
                made by or about you relating to the European Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                for communicating with our members effectively to respond to any
                queries or complaints.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Payment transaction information.
                </span>{' '}
                When you subscribe to our services, we may collect information
                such as your billing address and other information such as date
                and time of your transaction.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to process your orders through the
                European Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for the performance of a contract.
              </Text>
            </TableCell>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                We may also share your personal information with:
              </Text>
              <Text as="ul">
                <li>Impact Tech, Inc.</li>
                <li>Google LLC</li>
                <li>Facebook, Inc.</li>
                <li>Mode Analytics, Inc.</li>
                <li>Tableau Software, LLC</li>
                <li>RudderStack Inc.</li>
                <li>Reddit, Inc</li>
                <li>Brave Software, Inc.</li>
                <li>Twitter, Inc.</li>
                <li>LinkedIn Coproration</li>
                <li>Microsoft Corporation</li>
                <li>Outreach Corporation</li>
                <li>Cybba, Inc.</li>
                <li>Hotjar Ltd.</li>
                <li>Optimizely, Inc.</li>
                <li>Peaberry Software, Inc.</li>
                <li>Snap, Inc.</li>
                <li>TikTok, Inc.</li>
                <li>Twitch Interactive, Inc.</li>
                <li>Unbounce Marketing Solutions, Inc.</li>
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to verify your identity in
                connection with the detection and prevention of fraud or
                financial crime.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our and third partiers'
                legitimate interests, namely the detection and prevention of
                fraud and financial crime.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan="3">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Approximate Location information.
                </span>{' '}
                When you visit our European Services, we may collect information
                about your location. This information may be derived from WiFi
                positioning or your IP address.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We may use information to present the European Services to you
                on your device.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for performance of a contract with
                you.
              </Text>
            </TableCell>
            <TableCell rowSpan="3">
              <Text align="center" as="p">
                We may also share your personal information with:
              </Text>
              <Text as="ul">
                <li>Impact Tech, Inc.</li>
                <li>Google LLC</li>
                <li>Facebook, Inc.</li>
                <li>Mode Analytics, Inc.</li>
                <li>Tableau Software, LLC</li>
                <li>RudderStack Inc.</li>
                <li>Reddit, Inc</li>
                <li>Brave Software, Inc.</li>
                <li>Twitter, Inc.</li>
                <li>LinkedIn Coproration</li>
                <li>Microsoft Corporation</li>
                <li>Outreach Corporation</li>
                <li>Cybba, Inc.</li>
                <li>Hotjar Ltd.</li>
                <li>Optimizely, Inc.</li>
                <li>Peaberry Software, Inc.</li>
                <li>Snap, Inc.</li>
                <li>TikTok, Inc.</li>
                <li>Twitch Interactive, Inc.</li>
                <li>Unbounce Marketing Solutions, Inc.</li>
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to localise features of the European
                Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interest, namely
                localising features of the European Services and tailoring the
                European Services so that it is more relevant to our users.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to determine content that may be of
                interest to you.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                tailoring the European Services so that it is more relevant to
                you.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Chat, comments and opinions.
                </span>{' '}
                When you contact us directly, e.g. by email or phone we will
                record your comments and opinions.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to address your questions, issues
                and concerns.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests, namely
                communicating with you and responding to queries, complaints and
                concerns.
              </Text>
            </TableCell>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                We may share any information you provide to us when you contact
                us with: Freshworks Inc. Discord Inc. Telegram Group Inc.
                Meltwater Outreach Corporation
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to improve the European Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests (to
                develop and improve our service).
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Information received from third parties, such as social
                  networks.
                </span>{' '}
                If you interact with us through a social network, we may receive
                information from the social network such as your name, profile
                information, and any other information you permit the social
                network to share with third parties. We use single sign-on
                ("SSO") to allow a user to authenticate their account using one
                set of login information. The data we receive is dependent on
                your privacy settings with the social network.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to reshare content created through
                the use of the European Services
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interests (to
                develop our service and inform our marketing strategy)
              </Text>
            </TableCell>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                We may also share your personal information with:
              </Text>
              <Text as="ul">
                <li>Impact Tech, Inc.</li>
                <li>Google LLC</li>
                <li>Facebook, Inc.</li>
                <li>Mode Analytics, Inc.</li>
                <li>Tableau Software, LLC</li>
                <li>RudderStack Inc.</li>
                <li>Reddit, Inc</li>
                <li>Brave Software, Inc.</li>
                <li>Twitter, Inc.</li>
                <li>LinkedIn Coproration</li>
                <li>Microsoft Corporation</li>
                <li>Outreach Corporation</li>
                <li>Cybba, Inc.</li>
                <li>Hotjar Ltd.</li>
                <li>Optimizely, Inc.</li>
                <li>Peaberry Software, Inc.</li>
                <li>Snap, Inc.</li>
                <li>TikTok, Inc.</li>
                <li>Twitch Interactive, Inc.</li>
                <li>Unbounce Marketing Solutions, Inc.</li>
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We may use this information to authenticate you and allow you to
                access the European Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for the performance of a contract
                with you.
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                <span
                  style={{
                    fontWeight: 700
                  }}
                >
                  Your Preferences,
                </span>{' '}
                such as preferences set for notifications, marketing
                communications, how the European Services is displayed and the
                active functionalities on the European Services.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                We use this information to provide notifications, send news,
                alerts and marketing communications and provide the European
                Services in accordance with your choices.
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for our legitimate interest, namely
                ensuring the user receives the correct marketing and other
                communications, and that this is displayed in accordance with
                the user's preferences.
              </Text>
            </TableCell>
            <TableCell rowSpan="2">
              <Text align="center" as="p">
                We may also share your personal information with:
              </Text>
              <Text as="ul">
                <li>Impact Tech, Inc.</li>
                <li>Google LLC</li>
                <li>Facebook, Inc.</li>
                <li>Mode Analytics, Inc.</li>
                <li>Tableau Software, LLC</li>
                <li>RudderStack Inc.</li>
                <li>Reddit, Inc</li>
                <li>Brave Software, Inc.</li>
                <li>Twitter, Inc.</li>
                <li>LinkedIn Coproration</li>
                <li>Microsoft Corporation</li>
                <li>Outreach Corporation</li>
                <li>Cybba, Inc.</li>
                <li>Hotjar Ltd.</li>
                <li>Optimizely, Inc.</li>
                <li>Peaberry Software, Inc.</li>
                <li>Snap, Inc.</li>
                <li>TikTok, Inc.</li>
                <li>Twitch Interactive, Inc.</li>
                <li>Unbounce Marketing Solutions, Inc.</li>
              </Text>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Text align="center" as="p">
                We use this information to ensure that we comply with our legal
                obligation to send only those marketing communications to which
                you have consented
              </Text>
            </TableCell>
            <TableCell>
              <Text align="center" as="p">
                The processing is necessary for compliance with a legal
                obligation to which we are subject.
              </Text>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default Annex1Table

const TableCell = styled(BaseTableCell)`
  vertical-align: text-top !important;
`
